<div class="agent-tp">
  <div class="agent-tp__header">
    <h4>Attached Product Admins</h4>
    <button class="custom-btn" (click)="openAttachDialog()">
      <i class="pi pi-plus"></i> Attach
    </button>
  </div>

  <div class="agent-tp__table" *ngIf="!isLoading">
    <table *ngIf="attachedThirdParties.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let tp of attachedThirdParties">
          <tr class="third-party-row">
            <td>
              <div class="third-party-name">{{ tp.name || tp.third_party_name || '-' }}</div>
            </td>
            <td>
              <div class="action-btns">
                <button
                  class="action-btn users-btn"
                  (click)="openUsers(tp)"
                  pTooltip="Manage Users"
                  tooltipPosition="top"
                >
                  <i class="pi pi-users"></i>
                </button>
                <button class="action-btn view-btn" (click)="openCommissions(tp)" pTooltip="View Commissions" tooltipPosition="top">
                  <i class="pi pi-dollar"></i>
                </button>
                <button
                  class="action-btn detach-btn"
                  (click)="detach(tp.id)"
                  [disabled]="isDetaching[tp.id]"
                  pTooltip="Detach"
                  tooltipPosition="top"
                >
                  <i class="pi pi-spin pi-spinner" *ngIf="isDetaching[tp.id]"></i>
                  <i class="pi pi-times" *ngIf="!isDetaching[tp.id]"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="!attachedThirdParties.length" class="empty-state">
      No product admins attached to this agent.
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-state">
    <i class="pi pi-spin pi-spinner"></i> Loading...
  </div>
</div>

<!-- Attach Dialog -->
<p-dialog header="Attach Product Admins" [(visible)]="showAttachDialog" [modal]="true" [style]="{ width: '520px' }" [draggable]="false">
  <div class="attach-form">
    <div class="form-group">
      <label>Search</label>
      <input type="text" class="form-control" [(ngModel)]="tpSearch" (input)="onTpSearchInput()" placeholder="Search by name..." />
    </div>

    <div class="tp-list">
      <div *ngIf="isLoadingProductAdmins" class="loading-state">
        <i class="pi pi-spin pi-spinner"></i> Loading...
      </div>
      <div *ngIf="!isLoadingProductAdmins && !productAdminsList.length" class="empty-state">
        No product admins found.
      </div>
      <div
        *ngFor="let tp of productAdminsList"
        class="tp-item"
        [class.selected]="isSelected(tp.id)"
        (click)="toggleSelection(tp.id)"
      >
        <p-checkbox [binary]="true" [ngModel]="isSelected(tp.id)" (ngModelChange)="toggleSelection(tp.id)"></p-checkbox>
        <div class="tp-item__info">
          <span class="tp-item__name">{{ tp.name || '-' }}</span>
          <span class="tp-item__code" *ngIf="tp.code">{{ tp.code }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancel-btn" (click)="showAttachDialog = false">Cancel</button>
    <button class="custom-btn" [disabled]="!selectedThirdPartyIds.length || isAttaching" (click)="attach()">
      Attach ({{ selectedThirdPartyIds.length }})
      <i *ngIf="isAttaching" class="pi pi-spin pi-spinner"></i>
    </button>
  </ng-template>
</p-dialog>

<!-- Commissions Dialog -->
<p-dialog
  [header]="'Commissions — ' + (commissionsThirdParty?.name || commissionsThirdParty?.third_party_name || '')"
  [(visible)]="showCommissionsDialog"
  [modal]="true"
  [style]="{ width: '720px' }"
  [draggable]="false"
>
  <div *ngIf="!isLoadingCommissions">
    <table *ngIf="commissions.length" class="commissions-table">
      <thead>
        <tr>
          <th>Third Party</th>
          <th>Contract #</th>
          <th>Amount</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of commissions">
          <td>{{ c.third_party_name || '-' }}</td>
          <td>{{ c.contract_number || '-' }}</td>
          <td>{{ c.amount | currency:'USD' }}</td>
          <td>
            <span class="status-badge" [ngClass]="{
              'badge-active': c.contract_status === 'active' || c.contract_status === 'Active',
              'badge-cancelled': c.contract_status === 'cancelled' || c.contract_status === 'Cancelled'
            }">
              {{ c.contract_status || '-' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!commissions.length" class="empty-state">No commissions found.</div>

    <ngb-pagination
      *ngIf="commissionsTotalItems > commissionsRowsPerPage"
      [collectionSize]="commissionsTotalItems"
      [(page)]="commissionsCurrentPage"
      [pageSize]="commissionsRowsPerPage"
      [maxSize]="5"
      (pageChange)="onCommissionsPageChange($event)"
    ></ngb-pagination>
  </div>
  <div *ngIf="isLoadingCommissions" class="loading-state">
    <i class="pi pi-spin pi-spinner"></i> Loading commissions...
  </div>
</p-dialog>

<!-- Third-Party Users Dialog -->
<p-dialog
  [header]="'Users — ' + (usersThirdParty?.name || usersThirdParty?.third_party_name || '')"
  [(visible)]="showUsersDialog"
  [modal]="true"
  [style]="{ width: '780px' }"
  [draggable]="false"
>
  <div class="users-manager">
    <div class="users-manager__attach">
      <div class="users-manager__select">
        <label>Attach Sub-User</label>
        <p-dropdown
          [(ngModel)]="selectedSubUserId"
          [options]="availableSubUsers"
          optionLabel="displayName"
          optionValue="id"
          placeholder="Select sub-user"
          appendTo="body"
          [filter]="true"
          [disabled]="isLoadingAvailableSubUsers"
        ></p-dropdown>
      </div>
      <button
        class="custom-btn"
        [disabled]="!selectedSubUserId || isAttachingSubUser"
        (click)="attachSubUser()"
      >
        Attach
        <i *ngIf="isAttachingSubUser" class="pi pi-spin pi-spinner"></i>
      </button>
    </div>

    <div *ngIf="isLoadingThirdPartyUsers" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i> Loading users...
    </div>

    <table *ngIf="!isLoadingThirdPartyUsers && thirdPartyUsers.length" class="users-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of thirdPartyUsers">
          <td>{{ getUserName(user) }}</td>
          <td>{{ user?.email || '-' }}</td>
          <td>{{ user?.phone_number ? (user.phone_number | phoneNumber) : '-' }}</td>
          <td>
            <button
              class="action-btn detach-btn"
              [disabled]="detachingSubUserId === user.id"
              (click)="detachSubUser(user)"
              pTooltip="Detach User"
              tooltipPosition="top"
            >
              <i class="pi pi-spin pi-spinner" *ngIf="detachingSubUserId === user.id"></i>
              <i class="pi pi-times" *ngIf="detachingSubUserId !== user.id"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!isLoadingThirdPartyUsers && !thirdPartyUsers.length" class="empty-state">
      No sub-users attached to this third party.
    </div>

    <ngb-pagination
      *ngIf="usersTotalItems > usersRowsPerPage"
      [collectionSize]="usersTotalItems"
      [(page)]="usersCurrentPage"
      [pageSize]="usersRowsPerPage"
      [maxSize]="5"
      (pageChange)="onUsersPageChange($event)"
    ></ngb-pagination>
  </div>
</p-dialog>
